import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { memo, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../../../../App";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";
// AddItemThroughScanner, addToCartDedup, newCartItemsAddingProducts
// formerly imported here; now handled centrally by useAddToCart hook
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import useWeighingItemModal from "../../../hooks/useWeighingItemModal";
import {
  addManualItemsGTIN,
  addingProductTime,
  changeMultipleBatchesValue,
  changePrevAddedTime,
  incrementManuallyAddedProduct,
  setTotalProducts,
} from "../../redux/Actions/eventTracker";
import {
  searchTextRes,
  searchTextRespaymnet,
  setNewOds,
  setOdsCart,
} from "../../redux/Actions/paginationActions";
import {
  getFullState,
  getManuallyAddedProduct,
  getMultipleBatchValue,
  getTotalProducts,
} from "../../redux/Reducers/eventTrackerReducer";
import StyledButton from "../custom/StyledButton";
import CustomErrorModal from "../customErrorModal";
import BatchSelectionModal from "../twoWaykeyboardPaymentPage/components/batch-popup/index";
import CartItemDrawer from "../cartItemTable/Drawer/CartItemDrawer/CartItemDrawer";
import "./index.css";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "./../../../../../../utils/localStorageHelpers";
import Swal from "sweetalert2";
import { withSwalKeyboardNav } from "./../../../../../../utils/swalKeyboardNav";
import { useAddToCart } from "../../../hooks/useAddToCart";

const newSwal = Swal.mixin({
  customClass: {
    confirmButton: "button button-success",
    cancelButton: "button button-error",
    container: "my-swal-container",
  },
  buttonsStyling: false,
});

const WEIGHT_UNIT_LABELS = {
  kg: "Kilogram",
  kgs: "Kilogram",
  kilogram: "Kilogram",
  kilograms: "Kilogram",
  ltr: "Liter",
  ltrs: "Liter",
  litre: "Liter",
  litres: "Liter",
  liter: "Liter",
  liters: "Liter",
  l: "Liter",
  gm: "Gram",
  g: "Gram",
  gms: "Gram",
  grm: "Gram",
  gram: "Gram",
  grams: "Gram",
  ml: "ML",
  milliliter: "ML",
  milliliters: "ML",
  millilitre: "ML",
  millilitres: "ML",
  nos: "Nos",
  no: "Nos",
  pc: "Pieces",
  pcs: "Pieces",
  piece: "Pieces",
  pieces: "Pieces",
  each: "Each",
};

const formatWeightUnit = (unit) =>
  unit ? WEIGHT_UNIT_LABELS[unit.toString().trim().toLowerCase()] || unit : "";

const KeyboardDropDownModal = (props) => {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { addItemWithCheck, addItemDirect } = useAddToCart();
  const { findWeighingItem, renderWeighingModal, weighingStatus } = useWeighingItemModal();
  const dispatch = useDispatch();
  const [mrps, setMrps] = useState([]);
  const [selectedMrp, setSelectedMrp] = useState("");
  const [availableUnits, setAvailableUnits] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [SelectedSellingPrice, setSelectedSellingPrice] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [selectedGtin, setSelectedGtin] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const { openModalTwoway, setOpenModalTwoway } = useContext(UserContext);
  const { setanimationBox } = useContext(UserContext);
  const { setItemgtin, gtinItem } = useContext(UserContext);
  const [
    addItemThroughParticularCategoryItemLoader,
    setAddItemThroughParticularCategoryItemLoader,
  ] = useState(null);
  const { cartItems, setCartItems, setCartTotalQty, setSearchOpen } = useContext(UserContext);
  const { setSubTotal } = useContext(UserContext);
  const { setTotal } = useContext(UserContext);
  const { setCgst, setOfferFound, offerFound } = useContext(UserContext);
  const { highlightMrp, setHighlightMrp } = useContext(UserContext);
  const { setSgst, setCess, setHighlightedCartProductId } = useContext(UserContext);
  const CartId = localStorage.getItem("CartId");
  const [open, setOpen] = useState(false);

  const [brandName, setBrandName] = useState("");
  const [packagingType, setPackagingType] = useState("");
  const [variantName, setVariantName] = useState("");
  const [vendorId, setVendorId] = useState("");

  const [responseCartTimes, setResponseCartTimes] = useState(() => {
    const item = localStorage.getItem("responseCartTimes");
    try {
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.error("Error parsing 'responseCartTimes' from localStorage", error);
      return [];
    }
  });

  const [addItemResponseTime, setAddItemResponseTime] = useState(() => {
    const item = localStorage.getItem("addItemResponseTime");
    try {
      return item ? JSON.parse(item) : [];
    } catch (error) {
      console.error("Error parsing 'addItemResponseTime' from localStorage", error);
      return [];
    }
  });

  const allowNegativeSelling =
    !!getFromLocalStorage("appConfig")?.enabledFeatures?.NEGATIVE_INVENTORY;

  const showExpiry = !!getFromLocalStorage("appConfig")?.enabledFeatures?.MULTIPLE_BATCH_EXPIRY;

  const appDrawer = useSelector((state) => state.pagination.appDrawer);
  const { color, setColor, setSearchText } = useContext(UserContext);

  const [couponApplied, setCouponApplied] = useState("0");
  const [appliedState, setAppliedState] = useState(false);
  const [offerData, setOfferData] = useState(null);

  //add a item to cart

  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const [disabled, setDisabled] = useState(false);

  const [customErrorModal, setCustomErrorModal] = useState(false);
  const [customErrorOpenModal, setCustomErrorOpenModal] = useState(false);
  const [detailItem, setDetailItem] = useState(null); // product info drawer

  //order metrics
  const mannuallyEnteredProduct = useSelector(getManuallyAddedProduct);
  const multipleBatchCheck = useSelector(getMultipleBatchValue);
  const totalProducts = useSelector(getTotalProducts);
  const orderMetricDataFullState = useSelector(getFullState);
  const buttonRefs = useRef([]);

  const handleCloseCustomErrorModal = () => {
    setCustomErrorOpenModal(false);
  };

  // new cart apis changes

  const increseItemQuantityTroughParticularCategory = (
    gtin,
    name,
    index,
    packaging_type,
    sellingUnit
  ) => {
    const initialTime = new Date().getTime();
    setAddItemThroughParticularCategoryItemLoader(index);
    let payload = {
      gtin: gtin,
      cartId: props.listType === "search-ods" ? props.cartId : CartId,
      locationId: locId,
      orgId: orgId,
      allowNegativeSelling: allowNegativeSelling,
    };
    const start = new Date().getTime();
    /* Signature: (gtin, name, packagingType, sellingUnit, variant, odsCartId, type).
       Only pass an explicit cart id for the ODS flow — otherwise the hook must use
       the context cartId (passing a non-cart value here breaks the add). */
    if (findWeighingItem(gtin, name, packaging_type, sellingUnit, undefined,
      props.listType === "search-ods" ? props.cartId : undefined, props.listType)) {
      return;
    }
    // Error handling (stale cart, no cart, no-inventory) delegated to useAddToCart hook
    addItemWithCheck(payload, {
      onBeforeError: () => {
        setAddItemThroughParticularCategoryItemLoader(null);
        setSearchText("");
      },
      onBatchSelect: (dataArr) => {
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...addItemResponseTime,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
          setAddItemResponseTime(updatedResponseTimes);
        }
        if (dataArr.length === 1) {
          // Single batch — auto-add via addItem (handles expiry / negative-selling checks)
          addItem(
            dataArr[0].gtin, dataArr[0].mrp, dataArr[0].sellingPrice,
            dataArr[0].batchNo, dataArr[0].purchasePrice, dataArr[0].sellingUnit,
            dataArr[0].offers, dataArr[0].availableUnits, dataArr[0].expiryDate,
            dataArr[0].itemName, dataArr[0].vendorId, dataArr[0].packagingType,
            dataArr[0].haveOffer, dataArr[0].brand,
          );
          return;
        }
        // Multiple batches
        if (props.listType === "search-ods") {
          addItem(
            dataArr[0].gtin, dataArr[0].mrp, dataArr[0].sellingPrice,
            dataArr[0].batchNo, dataArr[0].purchasePrice, dataArr[0].sellingUnit,
            dataArr[0].offers, dataArr[0].availableUnits, dataArr[0].expiryDate,
            dataArr[0].itemName, dataArr[0].vendorId, dataArr[0].packagingType,
            dataArr[0].haveOffer, dataArr[0].brand,
          );
          dispatch(setNewOds(false));
          return;
        }
        dispatch(changeMultipleBatchesValue(true));
        localStorage.setItem("orderMetricData", JSON.stringify({
          ...orderMetricDataFullState, isMultipleBatch: true,
        }));
        setBrandName(dataArr[0].brand);
        setPackagingType(dataArr[0].packagingType);
        setVariantName(dataArr[0].itemName);
        setVendorId(dataArr[0].vendorId);
        setMrps(dataArr);
        setOfferData(dataArr[0].offers);
        setSelectedMrp(dataArr[0].mrp);
        setSelectedSellingPrice(dataArr[0].sellingPrice);
        setBatchNo(dataArr[0].batchNo);
        setPurchasePrice(dataArr[0].purchasePrice || "");
        setExpiryDate(dataArr[0].expiryDate || "");
        setSelectedGtin(dataArr[0].gtin);
        setDisabled(true);
        setSelectedProduct(name);
        setOpen(false);
        setOpenModalTwoway(true);
        setanimationBox(true);
        setItemgtin(gtin);
        setHighlightMrp(dataArr[0].sellingPrice);
        setSearchText("");
      },
      onError: (errMsg, errSource) => {
        // Network or non-API errors → plain snackbar (popup would be misleading)
        if (errSource === "network") {
          showSnackbar(errMsg || "Failed to add product", "error");
          return;
        }
        // API-level inventory error — show informational popup
        Swal.fire({
          title: "",
          html:
            `<div style="text-align:center;padding:4px 0 16px;">` +
              `<div style="width:60px;height:60px;border-radius:50%;background:#fef2f2;display:flex;align-items:center;justify-content:center;margin:0 auto 12px;border:2px solid #fecaca;">` +
                `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">` +
                  `<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>` +
                `</svg>` +
              `</div>` +
              `<p style="font-size:17px;font-weight:700;color:#0f172a;margin:0 0 4px;">No Inventory Found</p>` +
              `<p style="font-size:12.5px;color:#64748b;margin:0 0 16px;line-height:1.5;">${name || gtin}</p>` +
            `</div>` +
            `<div style="background:#fef2f2;border:1.5px solid #fecaca;border-radius:12px;padding:14px 16px;text-align:left;">` +
              `<p style="margin:0 0 6px;font-size:13px;font-weight:700;color:#991b1b;display:flex;align-items:center;gap:6px;">` +
                `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>` +
                `Cannot add to cart` +
              `</p>` +
              `<p style="margin:0;font-size:12.5px;color:#7f1d1d;line-height:1.65;">` +
                `This product has <strong>no inward records</strong>. Please complete a GRN (goods receipt note) in <strong>Pallet ROS</strong> before this product can be sold at the POS.` +
              `</p>` +
            `</div>`,
          showCancelButton: false,
          confirmButtonText: "Got it",
          width: "440px",
          buttonsStyling: false,
          willOpen: (popup) => {
            /* Keep the popup above the MUI search modal (z-index 1300) */
            const container = popup.closest(".swal2-container");
            if (container) container.style.zIndex = "99999";
          },
          didOpen: (popup) => {
            const confirmBtn = popup.querySelector(".swal2-confirm");
            if (confirmBtn) confirmBtn.style.cssText =
              "background:#2a71ff;color:#fff;border:none;padding:10px 28px;" +
              "border-radius:8px;font-weight:700;font-size:13.5px;cursor:pointer;min-width:120px;margin-top:16px;";
          },
        });
      },
      onSuccess: (response) => {
        // Cart state (cartItems, billing, offerFound, cartTotalQty) applied by useAddToCart hook
        setCouponApplied(response?.billing?.appliedCoupon);
        localStorage.removeItem("loyaltyPoints");
        setAppliedState(!appliedState);
        setAddItemThroughParticularCategoryItemLoader(null);
        setSelectedMrp("");
        setSelectedSellingPrice("");
        setBatchNo("");
        setPurchasePrice("");
        setSelectedGtin("");
        setSelectedProduct("");
        setMrps([]);
        setanimationBox(true);
        setItemgtin(gtin);
        setHighlightMrp(response?.cartProducts?.[0]?.sellingPrice);
        setOpen(false);
        setSearchText("");
        dispatch(searchTextRespaymnet(""));
        const currentTime = new Date().getTime();
        dispatch(incrementManuallyAddedProduct(mannuallyEnteredProduct + 1));
        dispatch(setTotalProducts(totalProducts + 1));
        dispatch(changePrevAddedTime(currentTime));
        dispatch(addingProductTime(currentTime - initialTime));
        dispatch(addManualItemsGTIN(gtin));
        const backupData = {
          ...orderMetricDataFullState,
          manuallyAdded: mannuallyEnteredProduct + 1,
          totalProducts: totalProducts + 1,
          prevAddedProductTime: currentTime,
          productTimeArray: [
            ...orderMetricDataFullState.productTimeArray,
            currentTime - initialTime,
          ],
          manualItemsGtin: orderMetricDataFullState.manualItemsGtin.includes(gtin)
            ? [...orderMetricDataFullState.manualItemsGtin]
            : [...orderMetricDataFullState.manualItemsGtin, gtin],
        };
        localStorage.setItem("orderMetricData", JSON.stringify(backupData));
        if (props.listType === "search-ods") {
          dispatch(setOdsCart(response?.cartProducts));
          dispatch(setNewOds(false));
          showSnackbar("Product added successfully", "success");
        } else {
          props.closeSearchProductModal();
        }
      },
    });
  };

  const isProfilerOn =
    // useMemo(() => {
    localStorage.getItem("profilerSwitch") === "true";
  // }, []);

  const addItem = async (
    gtin,
    mrp,
    sp,
    batchNo,
    purchasePrice,
    sellingUnit,
    offer,
    availableUnits,
    expiryDate,
    brand,
    packagingType,
    itemName,
    vendorId
  ) => {
    // Check expiry first
    if (showExpiry && expiryDate && new Date(expiryDate) < new Date()) {
      const expiryResult = await newSwal.fire(withSwalKeyboardNav({
        title: "Expired Product",
        text: "This product has expired. Do you want to proceed with selling?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed anyway",
        cancelButtonText: "Cancel",
        allowEnterKey: false,
        reverseButtons: true,
        willOpen: (popup) => {
          /* Keep the popup above the MUI batch modal (z-index 1300) */
          const container = popup.closest(".swal2-container");
          if (container) container.style.zIndex = "99999";
        },
      }));

      if (!expiryResult.isConfirmed) {
        console.log("User cancelled expired product selling operation");
        setAddItemThroughParticularCategoryItemLoader(null);
        return;
      }
    }

    // Check inventory only if expiry check passes
    if (!allowNegativeSelling && !availableUnits) {
      const inventoryResult = await newSwal.fire(withSwalKeyboardNav({
        title: "No inventory available",
        html:
          "<p style='font-size:14px;color:#374151;line-height:1.6;margin:0'>" +
          "This product has no inventory available.<br><br>" +
          "You can continue selling at the last inwarded batch selling price — " +
          "the system will tag this in <strong>oversold inventory</strong>." +
          "<br><br>Do you want to add to cart?" +
          "</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, add to cart",
        cancelButtonText: "Cancel",
        allowEnterKey: false,
        reverseButtons: true,
        willOpen: (popup) => {
          /* Keep the popup above the MUI batch modal (z-index 1300) */
          const container = popup.closest(".swal2-container");
          if (container) container.style.zIndex = "99999";
        },
      }));

      if (!inventoryResult.isConfirmed) {
        console.log("User cancelled negative selling operation");
        setAddItemThroughParticularCategoryItemLoader(null);
        return;
      }
    }

    // If both checks pass, proceed with adding item
    await proceedWithAddItem(
      gtin,
      mrp,
      sp,
      batchNo,
      purchasePrice,
      sellingUnit,
      offer,
      availableUnits,
      expiryDate,
      brand,
      packagingType,
      itemName,
      vendorId
    );
  };

  const proceedWithAddItem = async (
    gtin,
    mrp,
    sp,
    batchNo,
    purchasePrice,
    sellingUnit,
    offer,
    availableUnits,
    expiryDate,
    brand,
    packagingType,
    itemName,
    vendorId
  ) => {
    const intitalTime = new Date().getTime();
    setHighlightMrp(sp);
    const start = new Date().getTime();
    let payload = {
      cartId: CartId,
      gtin: selectedGtin || gtin,
      sellingPrice: sp,
      locationId: locId,
      mrp: mrp,
      inventoryChecks: "NO",
      isOfferAvailable:
        offer?.offersList.length > 0 || offerData?.offersList?.length > 0 ? true : false,
      batchNo: batchNo,
      purchasePrice: purchasePrice,
      sellingUnit: sellingUnit,
      expiryDate: expiryDate?.split("+")[0],
      variantName: itemName,
      vendorId: vendorId,
      packagingType: packagingType,
      brandName: brand,
    };

    // Error handling (stale cart, no cart, generic) delegated to useAddToCart hook
    await addItemDirect(payload, cartItems, {
      onBeforeError: () => {
        setAddItemThroughParticularCategoryItemLoader(null);
        setOpen(false);
        dispatch(searchTextRespaymnet(""));
        dispatch(searchTextRes(""));
      },
      onSuccess: (cartData) => {
        //cart-response-time
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...responseCartTimes,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("responseCartTimes", JSON.stringify(updatedResponseTimes));
          setResponseCartTimes(updatedResponseTimes);
        }
        if (multipleBatchCheck) {
          const currentTime = new Date().getTime();
          dispatch(incrementManuallyAddedProduct(mannuallyEnteredProduct + 1));
          dispatch(setTotalProducts(totalProducts + 1));
          dispatch(addingProductTime(currentTime - intitalTime));
          dispatch(changeMultipleBatchesValue(false));
          dispatch(addManualItemsGTIN(selectedGtin || gtin));
          localStorage.setItem("orderMetricData", JSON.stringify({
            ...orderMetricDataFullState,
            isMultipleBatch: false,
            manuallyAdded: mannuallyEnteredProduct + 1,
            totalProducts: totalProducts + 1,
            productTimeArray: [
              ...orderMetricDataFullState?.productTimeArray,
              currentTime - intitalTime,
            ],
            manualItemsGtin: orderMetricDataFullState?.manualItemsGtin?.includes(
              selectedGtin || gtin
            )
              ? [...orderMetricDataFullState?.manualItemsGtin]
              : [...orderMetricDataFullState?.manualItemsGtin, selectedGtin || gtin],
          }));
        }
        // Cart state (cartItems, billing, offerFound, cartTotalQty) applied by useAddToCart hook
        const sortedProducts = [...(cartData?.cartProducts || [])].sort((a, b) =>
          (b.modifiedDate || b.createdDate || "").localeCompare(a.modifiedDate || a.createdDate || "")
        );
        if (sortedProducts?.[0]?.cartProductId) {
          setHighlightedCartProductId(sortedProducts[0].cartProductId);
          setTimeout(() => setHighlightedCartProductId(null), 2000);
        }
        if (props?.listType === "search-ods") {
          dispatch(setOdsCart(cartData?.cartProducts));
          showSnackbar("Product added successfully", "success");
        }
        localStorage.removeItem("loyaltyPoints");
        setCouponApplied(cartData?.billing?.appliedCoupon);
        setAppliedState(!appliedState);
        setAddItemThroughParticularCategoryItemLoader(null);
        setSelectedMrp("");
        setSelectedSellingPrice("");
        setBatchNo("");
        setPurchasePrice("");
        setExpiryDate("");
        setSelectedGtin("");
        setSelectedProduct("");
        setMrps([]);
        setanimationBox(true);
        setItemgtin(gtin);
        setOpen(false);
        dispatch(searchTextRespaymnet(""));
        dispatch(searchTextRes(""));
        setSearchText("");
      },
    });
    /* Close the batch popup / search modal only after the item has been added */
    setOpenModalTwoway(false);
    if (props?.listType !== "search-ods") {
      props.closeSearchProductModal();
    }
  };

  useEffect(() => {
    if (!props.data || props.data.length === 0) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [props.data]);

  const handleClose = () => {
    setOpen(false);
    dispatch(searchTextRespaymnet(""));
  };

  const handleModalClose = () => {
    setOpenModalTwoway(false);
    setAddItemThroughParticularCategoryItemLoader(null);
  };

  const handlePrice = (
    mrp,
    sp,
    batchNo,
    purchasePrice,
    sellingunit,
    offer,
    availableUnits,
    expiryDate
  ) => {
    setDisabled(false);
    setSelectedMrp(mrp);
    setSelectedSellingPrice(sp);
    setBatchNo(batchNo);
    setPurchasePrice(purchasePrice);
    setOfferData(offer);
    setAvailableUnits(availableUnits);
    setExpiryDate(expiryDate);
  };

  useEffect(() => {
    if (weighingStatus === "done" && props.listType !== "search-ods") {
      setAddItemThroughParticularCategoryItemLoader(false);
      props.closeSearchProductModal();
    }
  }, [weighingStatus, props.listType]);

  const handleKeyDown = (event, index) => {
    if (!props.data || props.data.length === 0) return;
    if (props.listType !== "recent") return;
    if (event.key === "ArrowRight") {
      buttonRefs.current[(index + 1) % buttonRefs.current.length].focus();
    } else if (event.key === "ArrowLeft") {
      buttonRefs.current[
        (index - 1 + buttonRefs.current.length) % buttonRefs.current.length
      ].focus();
    } else if (event.key === "Enter") {
      buttonRefs.current[index]?.click();
    }
  };

  return (
    <div className="drop-down-modal-bg">
      {renderWeighingModal()}
      {customErrorModal ? (
        <CustomErrorModal
          customErrorOpenModal={customErrorOpenModal}
          handleCloseCustomErrorModal={handleCloseCustomErrorModal}
        />
      ) : null}

      {props?.data?.length === 0 ? (
        <>
          {props?.listType === "search-ods" ? (
            <Box className="no-display-no-result" />
          ) : props?.listType === "search" ? (
            /* ── Search returned zero results ── */
            <div className="kbd-empty-state">
              <div className="kbd-empty-icon kbd-empty-icon--search">
                <svg width="38" height="38" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round" aria-hidden="true">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.34-4.34" />
                  <path d="M8 11h6M11 8v6" opacity=".4" />
                </svg>
              </div>
              <p className="kbd-empty-heading">No products found</p>
              <p className="kbd-empty-sub">Try a different name, barcode, or category</p>
            </div>
          ) : (
            /* ── Initial / default state ── */
            <div className="kbd-empty-state">
              <div className="kbd-empty-icon kbd-empty-icon--scan">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round" aria-hidden="true">
                  <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                  <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                  <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                  <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                  <line x1="7" y1="12" x2="7" y2="12.01" />
                  <line x1="10" y1="8" x2="10" y2="16" />
                  <line x1="13" y1="10" x2="13" y2="14" />
                  <line x1="16" y1="8" x2="16" y2="16" />
                  <line x1="19" y1="12" x2="19" y2="12.01" />
                </svg>
              </div>
              <p className="kbd-empty-heading">Scan a barcode or search for a product</p>
              <p className="kbd-empty-sub">Results will appear here instantly</p>
              <div className="kbd-empty-hints">
                <span className="kbd-empty-hint-chip">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" aria-hidden="true">
                    <circle cx="11" cy="11" r="8"/><path d="m21 21-4.34-4.34"/>
                  </svg>
                  Type a product name
                </span>
                <span className="kbd-empty-hint-chip">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" aria-hidden="true">
                    <path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/>
                    <path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
                    <line x1="8" y1="12" x2="16" y2="12"/>
                  </svg>
                  Scan a barcode
                </span>
                <span className="kbd-empty-hint-chip">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                    strokeLinejoin="round" aria-hidden="true">
                    <rect x="2" y="3" width="20" height="14" rx="2"/>
                    <path d="M8 21h8M12 17v4"/>
                  </svg>
                  Browse categories
                </span>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {props?.listType == "recent" ? (
            <div>
              <p className="top-searches-title">Top Searches</p>
              <div className="top-searches-container">
                {props?.data
                  ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                  .slice(0, 5)
                  .map((e, i) => {
                    const productName = e?.variant?.name || e?.name || "";
                    const mrp = e?.variant?.inventorySync?.mrp;
                    const sp = e?.variant?.inventorySync?.sellingPrice;
                    const image =
                      (Array.isArray(e?.variant?.images)
                        ? e.variant.images[0]
                        : e?.variant?.images) || "";
                    const avatarColors = ["#2a71ff","#10b981","#f59e0b","#ef4444","#8b5cf6","#06b6d4","#f97316"];
                    const avatarBg = avatarColors[(productName?.charCodeAt(0) || 0) % avatarColors.length];
                    const isLoading = addItemThroughParticularCategoryItemLoader === i;
                    return (
                      <button
                        type="button"
                        key={i}
                        className="top-search-card"
                        ref={(ref) => (buttonRefs.current[i] = ref)}
                        onKeyDown={(event) => handleKeyDown(event, i)}
                        disabled={isLoading}
                        onClick={() =>
                          increseItemQuantityTroughParticularCategory(
                            e?.gtin || e?.variant?.barcodes?.[0],
                            productName,
                            i,
                            e?.variant?.needsWeighingScaleIntegration === true
                              ? "weighingScale"
                              : "Standard",
                            e?.variant?.weightUnit
                          )
                        }
                      >
                        {/* Product image / avatar */}
                        <div className="top-search-card-img-wrap">
                          {image ? (
                            <img
                              src={image}
                              alt={productName}
                              className="top-search-card-img"
                            />
                          ) : (
                            <span
                              className="top-search-card-avatar"
                              style={{ background: avatarBg }}
                            >
                              {productName.charAt(0).toUpperCase()}
                            </span>
                          )}
                          {isLoading && (
                            <div className="top-search-card-loader-overlay">
                              <CircularProgress size={18} sx={{ color: "#fff" }} />
                            </div>
                          )}
                        </div>
                        {/* Name */}
                        <p className="top-search-card-title">{productName}</p>
                        {/* Prices */}
                        <div className="top-search-card-price">
                          {mrp && (
                            <span className="top-search-card-mrp">{getStoreCurrencySymbol()}{mrp}</span>
                          )}
                          {sp && (
                            <span className="top-search-card-sp">{getStoreCurrencySymbol()}{sp}</span>
                          )}
                        </div>
                      </button>
                    );
                  })}
              </div>
            </div>
          ) : props?.listType === "search" || props?.listType === "search-ods" ? (
            <div
              className={
                isMobile
                  ? "DropDownModal-mobile drawer-dropdown-override"
                  : "DropDownModal-web-keyboard drawer-dropdown-override"
              }
              style={{
                ...(isMobile && { width: appDrawer ? "calc(100vw - 85px)" : "100%" }),
                display: open ? "flex" : "none",
              }}
            >
              {props?.listType === "search" && (
                <div
                  className="product-search-results-heading"
                  data-testid="text-product-search-results-heading"
                >
                  <span className="product-search-results-info-icon">i</span>
                  There are {props?.data?.length} results matching your search...
                </div>
              )}
              <div className="product-search-results-list">
                {props?.data?.map((item, index) => {
                  const isWeighing = item?.variant?.needsWeighingScaleIntegration === true;
                  /* Check both the boolean flag and the batch count for broader coverage */
                  const itemBatchCount = parseInt(item?.variant?.batchCount || 0, 10);
                  const hasMultipleBatches = item?.variant?.multipleBatches === true || itemBatchCount > 1;
                  /* Split inventory states — see ProductGrid for full explanation */
                  const itemInvSync        = item?.variant?.inventorySync;
                  const hasNoInventoryId   = !itemInvSync?.inventoryId;
                  const hasItemGrnPrice    = !!(itemInvSync?.mrp || itemInvSync?.sellingPrice);
                  const isOutOfStockEligible = hasNoInventoryId && hasItemGrnPrice;
                  const barcode = item?.variant?.barcodes?.[0] || "";
                  const productName = item?.variant?.name || item?.name || "";
                  const mrp = item?.variant?.inventorySync?.mrp || "";
                  const sp = item?.variant?.inventorySync?.sellingPrice || "";

                  /* Avatar colour for products without an image */
                  const AVATAR_COLORS = ["#2a71ff","#10b981","#f59e0b","#ef4444","#8b5cf6","#06b6d4","#f97316"];
                  const avatarBg = AVATAR_COLORS[(productName?.charCodeAt(0) || 0) % AVATAR_COLORS.length];

                  /* Best available image URL — no third-party placeholder fallback */
                  const imageUrl =
                    (Array.isArray(item?.variant?.images) ? item.variant.images[0] : null) ||
                    item?.variant?.images?.front ||
                    item?.variant?.images?.back  ||
                    item?.variant?.images?.left  ||
                    item?.variant?.images?.right ||
                    item?.variant?.images?.top   ||
                    item?.variant?.images?.bottom ||
                    item?.variant?.images?.top_left  ||
                    item?.variant?.images?.top_right ||
                    null;

                  /* Price helpers */
                  const mrpNum = parseFloat(mrp) || 0;
                  const spNum  = parseFloat(sp)  || 0;
                  const isDiscounted = mrpNum > 0 && spNum > 0 && spNum < mrpNum;

                  return (
                    <div
                      key={index}
                      id="myDropDownFocus"
                      className="product-search-card"
                      data-testid={`card-search-product-${index}`}
                    >
                      {/* Clickable area (image + details) — opens product detail drawer */}
                      <div
                        className="ps-clickable-body"
                        role="button"
                        tabIndex={0}
                        title="View product details"
                        onClick={() => barcode && setDetailItem({ gtin: barcode, productName, productImage: imageUrl })}
                        onKeyDown={(e) => e.key === "Enter" && barcode && setDetailItem({ gtin: barcode, productName, productImage: imageUrl })}
                      >
                      {/* Product image or coloured letter avatar */}
                      <div
                        className="product-search-image-container"
                        style={!imageUrl ? { background: avatarBg, display: "flex", alignItems: "center", justifyContent: "center" } : {}}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt={productName}
                            className="product-search-image"
                            data-testid={`img-search-product-${index}`}
                            onError={(e) => {
                              e.currentTarget.style.display = "none";
                              const p = e.currentTarget.parentElement;
                              p.style.cssText += `background:${avatarBg};display:flex;align-items:center;justify-content:center;`;
                              if (!p.querySelector(".ps-avatar-letter")) {
                                const s = document.createElement("span");
                                s.className = "ps-avatar-letter";
                                s.textContent = productName.charAt(0).toUpperCase();
                                p.appendChild(s);
                              }
                            }}
                          />
                        ) : (
                          <span className="ps-avatar-letter">
                            {productName.charAt(0).toUpperCase()}
                          </span>
                        )}
                      </div>

                      <div className="product-search-details">
                        <div className="product-search-title-row">
                          <p
                            className="product-search-name"
                            data-testid={`text-add-item-name-${index}`}
                          >
                            {productName}
                          </p>
                          {hasMultipleBatches && (
                            <span className="product-search-badge-batches" data-testid={`status-multiple-batches-${index}`}>
                              Batches
                            </span>
                          )}
                          {isWeighing && (
                            <span className="product-search-badge-scale" data-testid={`status-weighing-scale-product-${index}`}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="product-search-scale-icon" aria-hidden="true">
                                <circle cx="12" cy="5" r="3"></circle>
                                <path d="M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"></path>
                              </svg>
                              Scale
                            </span>
                          )}
                          {isWeighing && item?.variant?.weightUnit && (
                            <span className="product-search-badge-weight-unit" data-testid={`status-weight-unit-${index}`}>
                              {formatWeightUnit(item.variant.weightUnit)}
                            </span>
                          )}
                          {isOutOfStockEligible && (
                            <span className="product-search-badge-oos">
                              No stock · Eligible to sell
                            </span>
                          )}
                        </div>
                        {barcode && (
                          <p className="product-search-barcode" data-testid={`text-search-product-barcode-${index}`}>
                            {barcode}
                          </p>
                        )}
                      </div>
                      </div>{/* end ps-clickable-body */}

                      {/* Price column — strikethrough MRP when discounted */}
                      <div className="product-search-price-col">
                        <div className="product-search-price" data-testid={`text-search-product-mrp-${index}`}>
                          {isDiscounted ? (
                            <>
                              <span className="product-search-mrp product-search-mrp--disc">{getStoreCurrencySymbol()}{mrp}</span>
                              <span className="product-search-sp product-search-sp--highlight">{getStoreCurrencySymbol()}{sp}</span>
                            </>
                          ) : (
                            <>
                              <span className="product-search-mrp">MRP: {mrp ? `${getStoreCurrencySymbol()}${mrp}` : "N/A"}</span>
                              <span className="product-search-sp">SP: {sp ? `${getStoreCurrencySymbol()}${sp}` : "N/A"}</span>
                            </>
                          )}
                        </div>
                      </div>

                      {/* ADD button — inventory checks are handled by the backend */}
                      <button
                        type="button"
                        className="product-search-add-btn"
                        data-testid={`button-add-catalog-item-${index}`}
                        disabled={
                          !!addItemThroughParticularCategoryItemLoader ||
                          addItemThroughParticularCategoryItemLoader === 0
                        }
                        onClick={() =>
                          increseItemQuantityTroughParticularCategory(
                            barcode,
                            productName,
                            index,
                            isWeighing ? "weighingScale" : "Standard",
                            item?.variant?.weightUnit
                          )
                        }
                        autoFocus={index === props.currentIndex ? true : false}
                        onKeyDown={(e) => {
                          if (e.key === "ArrowLeft") {
                            e.preventDefault();
                            props.onFocusSidebar?.();
                          }
                        }}
                      >
                        {addItemThroughParticularCategoryItemLoader === index ? (
                          "Adding…"
                        ) : (
                          "Add"
                        )}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </>
      )}
      <BatchSelectionModal
        open={openModalTwoway}
        onClose={handleModalClose}
        mrps={mrps}
        disabled={disabled}
        selectedProduct={selectedProduct}
        selectedGtin={selectedGtin}
        handlePrice={handlePrice}
        addItemWithScanner={addItem}
        selectedMrp={selectedMrp}
        SelectedSellingPrice={SelectedSellingPrice}
        batchNo={batchNo}
        purchasePrice={purchasePrice}
        sellingUnit={0}
        offerData={offerData}
        availableUnits={availableUnits}
        expiryDate={expiryDate}
        brandName={brandName}
        packagingType={packagingType}
        variantName={variantName}
        vendorId={vendorId}
      />
      {detailItem && (
        <CartItemDrawer
          cartItemModalOpen={!!detailItem}
          setCartItemModalOpen={(v) => { if (!v) setDetailItem(null); }}
          cartItemData={detailItem}
        />
      )}
    </div>
  );
};

export default memo(KeyboardDropDownModal);
